import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OauthDescribeSuccessResponse } from '../lib-api/services/Oauth';

export type OauthStoreDescription = OauthDescribeSuccessResponse;

export type OauthStoreState = {
  description?: OauthStoreDescription;
};

const initialState: OauthStoreState = {
  description: undefined,
};

export const oauthSlice = createSlice({
  name: 'oauth',
  initialState,
  reducers: {
    getOauthDescriptionSuccess: (state, action: PayloadAction<OauthStoreDescription>) => {
      state.description = action.payload;
    },
  },
});

export const { getOauthDescriptionSuccess } = oauthSlice.actions;
